import { Controller } from "@hotwired/stimulus"
import { draftKey, readDraft, ageText } from "../modules/product_draft.mjs"
import { purgeUpload } from "../modules/direct_upload_purge.js"

// Aviso del borrador local en Mis productos: Continuar (new?draft=continue), Descartar (borra y purga
// la foto) y `clear` cuando el servidor confirmó el guardado.
// Doc: _docs/features/products/product_wizard_draft.md
export default class extends Controller {
  static targets = ["notice", "age"]
  static values = { store: Number, clear: Boolean }

  connect() {
    // Un preview de Turbo no muestra ni borra nada
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    this.key = draftKey({ storeId: this.storeValue })
    if (this.clearValue) {
      // Se apaga antes de borrar: el snapshot de Turbo de esta página no debe volver a borrar
      this.clearValue = false
      this.#remove()
      return
    }
    this.draft = this.#read()
    if (!this.draft) return
    this.ageTarget.textContent = ageText(this.draft.savedAt)
    this.noticeTarget.hidden = false
  }

  discard() {
    const draft = this.draft
    this.draft = null
    this.noticeTarget.hidden = true
    this.#remove()
    const signedId = draft?.product?.photo?.signedId
    if (signedId) purgeUpload(signedId)
  }

  #remove() {
    try { localStorage.removeItem(this.key) } catch { /* sin storage no hay nada que borrar */ }
  }

  #read() {
    return readDraft(localStorage, this.key, { storeId: this.storeValue })
  }
}
